<template>
  <UToggle
    v-model="_value"
    :disabled="disabled"
    size="2xl"
  />
</template>

<script>
export default {
  name: 'BToggle',
  props: {
    value: {
      type: Boolean,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: this._uid
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
        this.$emit('change', value)
      }
    }
  }
}
</script>